import { create } from 'zustand'
import { BonusesSlice, createBonusesSlice } from './slices/bonusesSlice'

export interface FreeSpinsBonusesStoreState {
    hasActiveBonusesLeft: boolean
    setHasActiveBonusesLeft: (hasMore: boolean) => void
    remainingSpins: number
    setRemainingSpins: (remainingSpins: number) => void
    showRemainingSpinsBanner: boolean
    setShowRemainingSpinsBanner: (shouldShow: boolean) => void
    isModalOpened: boolean
    setIsModalOpened: (isModalOpened: boolean) => void
    isThereClaimingError: boolean
    setIsThereClaimingError: (isThereClaimingError: boolean) => void
    isBonusAlreadyClaimed: boolean
    setIsBonusAlreadyClaimed: (isBonusAlreadyClaimed: boolean) => void
    isRecovery: boolean
    setIsRecovery: (isRecovery: boolean) => void
    isFreespinsPressStartCounterActive: boolean
    setIsFreespinsPressStartCounterActive: (isActive: boolean) => void
}

export const useFreeSpinsBonusesStore = create<FreeSpinsBonusesStoreState & BonusesSlice>((set) => ({
    isRecovery: false,
    setIsRecovery: (isRecovery: boolean) => {
        set({ isRecovery })
    },
    isFreespinsPressStartCounterActive: false,
    setIsFreespinsPressStartCounterActive: (isActive: boolean) => {
        set({ isFreespinsPressStartCounterActive: isActive })
    },
    isBonusAlreadyClaimed: false,
    setIsBonusAlreadyClaimed: (isBonusAlreadyClaimed: boolean) => {
        set({ isBonusAlreadyClaimed })
    },
    isThereClaimingError: false,
    setIsThereClaimingError: (isThereClaimingError: boolean) => {
        set({ isThereClaimingError })
    },
    hasActiveBonusesLeft: false,
    setHasActiveBonusesLeft: (hasActiveBonusesLeft: boolean) => {
        set({ hasActiveBonusesLeft })
    },
    remainingSpins: 0,
    setRemainingSpins: (remainingSpins: number) => {
        set({ remainingSpins })
    },
    showRemainingSpinsBanner: false,
    setShowRemainingSpinsBanner: (shouldShow: boolean) => {
        set({ showRemainingSpinsBanner: shouldShow })
    },
    isModalOpened: false,
    setIsModalOpened: (isModalOpened: boolean) => set({ isModalOpened }),
    ...createBonusesSlice(set),
}))
